@import url('https://fonts.googleapis.com/css2?family=Figtree:ital,wght@0,300..900;1,300..900&display=swap');

@config "../tailwind.config.ts";
@import 'tailwindcss/theme.css' layer(theme);
@import 'tailwindcss/preflight.css' layer(base);
@import 'tailwindcss/utilities.css';
@import 'nativewind/theme';

@layer base {
  :root {
    --app-dvh: 100dvh;
    --safe-area-bottom: env(safe-area-inset-bottom, 0px);
    font-size: 14px;
    font-family: 'Figtree', system-ui, sans-serif;
    color: hsl(184, 42%, 14%);
  }

  html {
    min-height: var(--app-dvh);
    height: var(--app-dvh);
    overscroll-behavior: none;
    background-color: hsl(184, 42%, 14%);
    font-family: 'Figtree', system-ui, sans-serif;
  }

  body {
    min-height: var(--app-dvh);
    height: var(--app-dvh);
    margin: 0;
    padding: 0;
    overscroll-behavior: none;
    position: relative;
    width: 100%;
    background-color: hsl(184, 42%, 14%);
  }

  #root {
    min-height: var(--app-dvh);
    height: var(--app-dvh);
    background-color: hsl(184, 42%, 14%);
  }
}

@layer utilities {
  input[type='tel'],
  input[type='tel']:focus {
    -webkit-user-select: auto !important;
    user-select: auto !important;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
  }

  .pb-safe {
    padding-bottom: var(--safe-area-bottom);
  }

  .mb-safe {
    margin-bottom: var(--safe-area-bottom);
  }
}

@keyframes blob-in {
  from {
    opacity: 0;
    transform: scale(0) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.animate-blob-in-top-left {
  transform-origin: top left;
  animation: blob-in 0.3s ease-out forwards;
}

.animate-blob-in-top-center {
  transform-origin: top center;
  animation: blob-in 0.3s ease-out forwards;
}

.animate-blob-in-top-right {
  transform-origin: top right;
  animation: blob-in 0.3s ease-out forwards;
}
